import * as React from 'react';
import { useHistory } from 'react-router';
import { Container, ImageContainer, UploadButton } from './NoData.styles';

export default ({
  buttonText = 'upload data',
  description = 'Please upload data for classification',
  link = '/settings/data',
  text = 'No Data Available',
}: {
  buttonText?: string;
  description?: string;
  link?: string;
  text?: string;
}) => {
  const history = useHistory();
  return (
    <Container>
      <ImageContainer />
      <h2>{text}</h2>
      <br />
      <h6>{description}</h6>
      <UploadButton
        iconName="cloud_upload"
        onClick={() => {
          history.push(link);
        }}
      >
        {buttonText}
      </UploadButton>
    </Container>
  );
};
